<!--Maakt gebruik van: https://bootstrap-vue.org/vue3-->
<template>
    <!-- Payment template -->
    <div>
        <div class="row">
            <div class="col-md-12">
                <h2>3. Payment</h2>
                <div class="paymentContainer" style="padding-bottom:20px; border-bottom: 1px dotted #ccc; margin-bottom: 40px;">
                    <h4>{{getInterfaceText('shop_choosepaymentmethod')}}</h4>
                    <p v-if="paymentoption != undefined && paymentoption.length > 0 && paymentoption.Code != undefined">{{paymentoption.Code}}</p>
                    <b-form-group>
                        <div v-for="paymentoption in Cart.PaymentOptions" :key="paymentoption" :class="'paymentOption paymentOption-' + paymentoption.code + (paymentoption.disabled ? ' paymentOption-inactive' : '')" v-show="paymentoption.show">
                            <div class="row">
                                <div class="col-md-1 text-right">
                                    <b-form-radio aria-describedby="errorPaymentAlert" type="radio" v-model="selectedPaymentoption" name="paymentoption" :id="paymentoption.code" :value="paymentoption" class="payment-option-radio" :disabled="(completeInProgress == true || paymentoption.disabled == true)"></b-form-radio>
                                </div>
                                <div class="col-md-7" style="padding-left:0;">
                                    <label class="payment-option-label" :for="paymentoption.code" style="font-weight: bold;line-height: initial;">{{paymentoption.Name}}</label>
                                    <div class="description" v-show="paymentoption.disabled == true" v-html="paymentoption.DisabledText" />
                                    <div class="description" v-show="paymentoption.disabled == false" v-html="paymentoption.Description" />
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-5 text-right">
                                    <img :src="paymentoption.Image" class="payment-logo" :alt="paymentoption.Description + ' Logo ' + paymentoption.Code" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-1 text-right"></div>
                                <div class="col-md-11" style="padding-left:0;">
                                    <div class="paymentExtraData" v-if="paymentoption.code == 'stripe2'" v-show="selectedPaymentoption != null && selectedPaymentoption.code == 'stripe2'">
                                        <p v-if="paymentoption.Description2 != undefined && paymentoption.Description2.length > 0" v-html="paymentoption.Description2" />
                                        <div v-show="Cart.ShippingType == 'pickup' && (Cart.CountryId == 19 || Cart.CountryId == 48 || Cart.CountryId == 8 || Cart.CountryId == 29)">
                                            <label>{{getInterfaceText('shop_nameoncardmustmatch',Cart.Order.Lastname)}}</label>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 col-sm-6 col-xs-12">
                                                <label for="card-number-element">{{getInterfaceText('shop_creditcard_number')}}</label>
                                            </div>
                                            <div class="col-md-6 col-sm-6 col-xs-12 form-control" id="card-number-element" style="width:180px; margin-left:16px;">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 col-sm-6 col-xs-12">
                                                <label for="card-cvc-element"><span>{{getInterfaceText('shop_creditcard_securitycode')}}</span></label>
                                            </div>
                                            <div class="col-md-6 col-sm-6 col-xs-12 form-control" id="card-cvc-element" style="width:80px; margin-left:16px;">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 col-sm-6 col-xs-12">
                                                <label for="card-expiry-element">{{getInterfaceText('shop_creditcard_expiration')}}</label>
                                            </div>
                                            <div class="col-md-6 col-sm-6 col-xs-12 form-control" id="card-expiry-element" style="width:80px; margin-left:16px;">
                                            </div>
                                        </div>

                                        <div v-if="ShowStripeBillingAddress">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <h4>{{getInterfaceText('shop_creditcard_holdersdetails')}}</h4>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <input type="checkbox" id="useShippingAddress" v-model="creditcardAddress.useShippingAddress" v-on:change="toggleUseShippingAddress()" style="margin-right:4px;" />
                                                    <label for="useShippingAddress">{{getInterfaceText('shop_creditcard_useshippingaddressdetails')}}</label>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-6 col-sm-6 col-xs-12">
                                                    <label for="Order.OrderBillingAddressName">{{getInterfaceText('shop_creditcard_nameoncard')}}</label>
                                                </div>
                                                <div class="col-md-6 col-sm-6 col-xs-12">
                                                    <b-form-input type="text" id="Order.OrderBillingAddressName" aria-describedby="Order.OrderBillingAddressName.Required" name="Order.OrderBillingAddressName" v-model="creditcardAddress.name" class="form-control" required />
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-6 col-sm-6 col-xs-12">
                                                    <label for="Order.OrderBillingAddressStreet">{{getInterfaceText('shop_creditcard_streetaddress')}}</label>
                                                </div>
                                                <div class="col-md-6 col-sm-6 col-xs-12">
                                                    <b-form-input type="text" id="Order.OrderBillingAddressStreet" aria-describedby="Order.OrderBillingAddressStreet.Required" name="Order.OrderBillingAddressStreet" v-model="creditcardAddress.street" required data-stripe="address_line1" class="form-control" />
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-6 col-sm-6 col-xs-12">
                                                    <label for="Order.OrderBillingAddressPostalcode">{{getInterfaceText('shop_creditcard_number')}}</label>
                                                </div>
                                                <div class="col-md-2 col-sm-2 col-xs-12">
                                                    <b-form-input type="text" id="Order.OrderBillingAddressPostalcode" aria-describedby="Order.OrderBillingAddressPostalcode.Required" :placeholder="getInterfaceText('form_zipcode')" name="Order.OrderBillingAddressPostalcode" v-model="creditcardAddress.zipcode" required data-stripe="address_zip" class="form-control" />
                                                </div>
                                                <div class="col-md-4 col-sm-4 col-xs-12">
                                                    <b-form-input type="text" id="Order.OrderBillingAddressCity" aria-describedby="Order.OrderBillingAddressCity.Required" :placeholder="getInterfaceText('form_city')" name="Order.OrderBillingAddressCity" v-model="creditcardAddress.city" class="form-control" required />
                                                </div>
                                            </div>
                                            <div class="row" v-if="Cart.CountryId == 1 || Cart.CountryId == 10">
                                                <div class="col-md-6 col-sm-6 col-xs-12">
                                                    <label for="Order.OrderBillingAddressState">{{getInterfaceText('shop_creditcard_state')}}</label>
                                                </div>
                                                <div class="col-md-6 col-sm-6 col-xs-12">
                                                    <b-form-select name="Order.OrderBillingAddressState" aria-describedby="Order.OrderBillingAddressState.Required" id="Order.OrderBillingAddressState" class="form-control" v-model="creditcardAddress.state" :options="Cart.CountryId == 1 ? availableStatesUSA : Cart.CountryId == 10 ? availableStatesCA : null" required></b-form-select>
                                                </div>
                                            </div>
                                            <input type="hidden" id="Order.OrderBillingAddressCountry" name="Order.OrderBillingAddressCountry" :value="countryCode" />
                                        </div>
                                    </div>
                                    <div class="paymentExtraData" v-if="paymentoption.code == 'klarnaPayLater'" v-show="selectedPaymentoption != null && selectedPaymentoption.code == 'klarnaPayLater'">
                                        <p v-if="paymentoption.Description2 != undefined && paymentoption.Description2.length > 0" v-html="paymentoption.Description2" />
                                        <div id="klarna-payments-container-pay_later"></div>
                                    </div>
                                    <div class="paymentExtraData" v-if="paymentoption.code == 'klarnaOverTime'" v-show="selectedPaymentoption != null && selectedPaymentoption.code == 'klarnaOverTime'">
                                        <p v-if="paymentoption.Description2 != undefined && paymentoption.Description2.length > 0" v-html="paymentoption.Description2" />
                                        <div id="klarna-payments-container-pay_over_time"></div>
                                    </div>
                                    <div class="paymentExtraData" v-if="paymentoption.code == 'cyclescheme'" v-show="selectedPaymentoption != null && selectedPaymentoption.code == 'cyclescheme'">
                                        <div class="row">
                                            <div class="col-md-5 col-sm-6 col-xs-12">
                                                <label for="CycleSchemeNumber">{{getInterfaceText('shop_entercycleschemecertificatenumber')}}</label>
                                            </div>
                                            <div class="col-md-7 col-sm-6 col-xs-12">
                                                <b-form-input type="text" id="CycleSchemeNumber" aria-describedby="CycleSchemeNumber.Required" name="CycleSchemeNumber" v-model="cyclescheme.Number" required class="form-control" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5 col-sm-6 col-xs-12">
                                                <label for="CycleSchemeCode">{{getInterfaceText('shop_entercycleschemeredemptioncode')}}</label>
                                            </div>
                                            <div class="col-md-7 col-sm-6 col-xs-12">
                                                <b-form-input type="text" id="CycleSchemeCode" aria-describedby="CycleSchemeNumber.Required" name="CycleSchemeCode" v-model="cyclescheme.Code" required class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-form-group>
                </div>
                <b-form-checkbox v-if="showTerms" id="agreeToTermsAndConditions" name="agreeToTermsAndConditions" aria-describedby="errorPaymentAlert" required v-model="checkTermsAndConditions" unchecked-value="not_accepted">
                    <a class="agree-terms-conditions" data-toggle="modal" data-target="#termsModal" href="javascript:void(0);" style="margin-left:10px;">{{getInterfaceText('shop_approveTermsAndConditions')}}</a>
                </b-form-checkbox>
                <b-form-checkbox v-if="showPrivacy" v-model="checkPrivacy" name="agreeToPrivacy" required>
                    <a class="agree-terms-conditions" data-toggle="modal" data-target="#privacyModal" href="javascript:void(0);" style="margin-left:10px;">{{getInterfaceText('giantid_check_privacy')}}</a>
                </b-form-checkbox>

                <!--@Html.ValidationMessage("agreeToTermsAndConditions")-->
                <!--@if (Model.Privacy != null)
                {-->
                <!--Html.RenderPartial("_PageModal", Model.Privacy);
                }-->
                <div class="" style="margin-top: 20px;">
                    <div id="errorPaymentAlert" class="alert alert-danger" role="alert" v-show="errorPayment != undefined && errorPayment.length > 0" v-html="errorPayment"></div>
                    <button type="button" id="btnConfirm" v-hide="selectedPaymentoption != null && (selectedPaymentoption.code == 'stripeApplePay' || paymentoption == 'stripeGooglePay')" v-on:click="Pay()" :class="proceedPaymentButtonClicked == true && errorPayment.length == 0 ? 'btn-run-progress' : ''" v-disabled="(proceedPaymentButtonClicked == true && errorPayment.length == 0) || paymentButtonDisabled == true ? 'btn-run-progress' : ''" class="btn btn-success btnConfirm hidden-xs" style="float:left;margin-right:20px;">
                        <span>{{PayButtonLabel}} <i class="glyphicon glyphicon-menu-right" aria-hidden="true"></i></span>
                    </button>
                    <div id="payment-request-button" v-show="selectedPaymentoption != null && (selectedPaymentoption.code == 'stripeApplePay' || selectedPaymentoption.code == 'stripeGooglePay')">
                        <!-- A Stripe Element will be inserted here. -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import vueStore from '../store/store.js';
    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'payment',
        mixins: [cartMixin, generalMixin],
        props: ['showTerms', 'showPrivacy'],
        template: '#payment',
        data: function () {
            return {
                selectedPaymentoption: null,
                creditcardAddress: {},
                countryCode: window.countryCode,
                checkPrivacy: false,
                checkTermsAndConditions: false,
                availableStatesUSA: [
                    { value: null, text: this.getInterfaceText('shop_selectstate') },
                    { value: 'AL', text: 'Alabama' },
                    { value: 'AK', text: 'Alaska' },
                    { value: 'AZ', text: 'Arizona' },
                    { value: 'AR', text: 'Arkansas' },
                    { value: 'CA', text: 'California' },
                    { value: 'CO', text: 'Colorado' },
                    { value: 'CT', text: 'Connecticut' },
                    { value: 'DE', text: 'Delaware' },
                    { value: 'DC', text: 'District of Columbia' },
                    { value: 'FL', text: 'Florida' },
                    { value: 'GA', text: 'Georgia' },
                    { value: 'HI', text: 'Hawaii' },
                    { value: 'ID', text: 'Idaho' },
                    { value: 'IL', text: 'Illinois' },
                    { value: 'IN', text: 'Indiana' },
                    { value: 'IA', text: 'Iowa' },
                    { value: 'KS', text: 'Kansas' },
                    { value: 'KY', text: 'Kentucky' },
                    { value: 'LA', text: 'Louisiana' },
                    { value: 'ME', text: 'Maine' },
                    { value: 'MD', text: 'Maryland' },
                    { value: 'MA', text: 'Massachusetts' },
                    { value: 'MI', text: 'Michigan' },
                    { value: 'MN', text: 'Minnesota' },
                    { value: 'MS', text: 'Mississippi' },
                    { value: 'MO', text: 'Missouri' },
                    { value: 'MT', text: 'Montana' },
                    { value: 'NE', text: 'Nebraska' },
                    { value: 'NV', text: 'Nevada' },
                    { value: 'NH', text: 'New Hampshire' },
                    { value: 'NJ', text: 'New Jersey' },
                    { value: 'NM', text: 'New Mexico' },
                    { value: 'NY', text: 'New York' },
                    { value: 'NC', text: 'North Carolina' },
                    { value: 'ND', text: 'North Dakota' },
                    { value: 'OH', text: 'Ohio' },
                    { value: 'OK', text: 'Oklahoma' },
                    { value: 'OR', text: 'Oregon' },
                    { value: 'PA', text: 'Pennsylvania' },
                    { value: 'PR', text: 'Puerto Rico' },
                    { value: 'RI', text: 'Rhode Island' },
                    { value: 'SC', text: 'South Carolina' },
                    { value: 'SD', text: 'South Dakota' },
                    { value: 'TN', text: 'Tennessee' },
                    { value: 'TX', text: 'Texas' },
                    { value: 'UT', text: 'Utah' },
                    { value: 'VT', text: 'Vermont' },
                    { value: 'VA', text: 'Virginia' },
                    { value: 'WA', text: 'Washington' },
                    { value: 'WV', text: 'West Virginia' },
                    { value: 'WI', text: 'Wisconsin' },
                    { value: 'WY', text: 'Wyoming' }
                ],
                availableStatesCA: [
                    { value: null, text: this.getInterfaceText('shop_selectstate') },
                    { value: 'AB', text: 'Alberta' },
                    { value: 'BC', text: 'British Columbia' },
                    { value: 'MB', text: 'Manitoba' },
                    { value: 'NB', text: 'New Brunswick' },
                    { value: 'NL', text: 'Newfoundland and Labrador' },
                    { value: 'NS', text: 'Nova Scotia' },
                    { value: 'NT', text: 'Northwest Territories' },
                    { value: 'NU', text: 'Nunavut' },
                    { value: 'ON', text: 'Ontario' },
                    { value: 'PE', text: 'Prince Edward Island' },
                    { value: 'QC', text: 'Quebec' },
                    { value: 'SK', text: 'Saskatchewan' },
                    { value: 'YT', text: 'Yukon' }
                ],
                StripeClientSecret: '',
                proceedPaymentButtonClicked: false,
                cardNumberElement: '',
                errorPayment: '',
                klarnaAuthorizationToken: '',
                cyclescheme: { Number: '', Code: '' }
            }
        },
        methods: {
            toggleUseShippingAddress() {
                if (this.creditcardAddress.useShippingAddress) {
                    this.creditcardAddress.name = this.Order.Firstname + ' ' + this.Order.Lastname;
                    this.creditcardAddress.street = this.Order.Street;
                    this.creditcardAddress.zipcode = this.Order.Postalcode;
                    this.creditcardAddress.city = this.Order.City;
                    this.creditcardAddress.state = this.Order.State;
                } else {
                    this.creditcardAddress.name = '';
                    this.creditcardAddress.street = '';
                    this.creditcardAddress.zipcode = '';
                    this.creditcardAddress.city = '';
                    this.creditcardAddress.state = '';
                }
            },
            initiateStripe() {
                var that = this;
                this.stripeElements.create('paymentRequestButton', {
                    paymentRequest: that.paymentStripeRequest,
                });

                this.paymentStripeRequest.on('paymentmethod', function () { that.StripePaymentRequest(); });

                var style = {
                    base: {
                        '::placeholder': {
                            color: '#c7c7c7'
                        }
                    }
                };

                this.cardNumberElement = this.stripeElements.create('cardNumber', {
                    style: style,
                    placeholder: this.getInterfaceText('shop_placeholder_inputfield_credit_card_number'),
                });
                this.cardNumberElement.mount('#card-number-element');

                var cardExpiryElement = this.stripeElements.create('cardExpiry', {
                    style: style,
                    placeholder: this.getInterfaceText('shop_placeholder_inputfield_credit_card_expiry'),
                });
                cardExpiryElement.mount('#card-expiry-element');

                var cardCvcElement = this.stripeElements.create('cardCvc', {
                    style: style,
                    placeholder: this.getInterfaceText('shop_placeholder_inputfield_credit_card_cvc'),
                });
                cardCvcElement.mount('#card-cvc-element');
            },
            initiatestripeAppleGooglePay() {
                var that = this;
                var prButton = this.stripeElements.create('paymentRequestButton', { paymentRequest: that.paymentRequest });

                // Check the availability of the Payment Request API first.
                this.paymentRequest.canMakePayment().then(function (result) {
                    console.log('ApplePay/GooglePay canMakePayment: ' + result);
                    if (result && (result.applePay == true || result.googlePay == true)) {
                        prButton.mount('#payment-request-button');
                    } else {
                        that.errorPayment = 'This payment is not possible: ' + result;
                    }
                });
            },
            initiateKlarna(code) {
                var that = this;
                axios({
                    method: "get",
                    url: '/' + window.culture + '/shop/klarna-initiate',
                }).then(function (res) {
                    try {
                        if (res.data.key != null) {
                            window.Klarna.Payments.init({
                                client_token: res.data.key
                            });
                            window.Klarna.Payments.load({
                                container: '#klarna-payments-container-' + code,
                                //payment_method_category: code
                                payment_method_category: code
                            }, function (res) {
                                window.log(res);
                                if (res.show_form == false) {
                                    that.errorPayment = 'This payment option is not available';
                                }
                            });
                        } else {
                            that.errorPayment = res.data.error;
                        }
                    } catch (e) {
                        // Handle error.
                    }
                });
            },
            StripePaymentRequest(ev) {
                var that = this;
                // Confirm the PaymentIntent without handling potential next actions (yet).
                this.errorPayment = '';
                this.CompleteStripeAppleOrGooglePay(function () {
                    window.stripe.confirmCardPayment(
                        that.StripeClientSecret,
                        { payment_method: ev.paymentMethod.id },
                        { handleActions: false }
                    ).then(function (confirmResult) {
                        if (confirmResult.error) {
                            // Report to the browser that the payment failed, prompting it to
                            // re-show the payment interface, or show an error message and close
                            // the payment interface.
                            ev.complete('fail');
                            this.errorPayment = confirmResult.error;
                        } else {
                            // Report to the browser that the confirmation was successful, prompting
                            // it to close the browser payment method collection interface.
                            ev.complete('success');
                            // Check if the PaymentIntent requires any actions and if so let Stripe.js
                            // handle the flow. If using an API version older than "2019-02-11"
                            // instead check for: `paymentIntent.status === "requires_source_action"`.
                            if (confirmResult.paymentIntent.status === "requires_action") {
                                // Let Stripe.js handle the rest of the payment flow.
                                window.stripe.confirmCardPayment(that.StripeClientSecret).then(function (result) {
                                    if (result.error) {
                                        // The payment failed -- ask your customer for a new payment method.
                                        //scope.completeInProgress = false;
                                        this.errorPayment = result.error;
                                    } else {
                                        // The payment has succeeded.
                                        this.StripeStateChange();
                                    }
                                });
                            } else {
                                // The payment has succeeded.
                                this.StripeStateChange();
                            }
                        }
                    });
                });
            },
            CompleteStripeAppleOrGooglePay(callback, method) {
                this.$emit('setLoadingFromChild', true);
                var that = this;
                var paymentmethod = 'applepay=true';
                if (method != null && method == 'googlepay') {
                    paymentmethod = 'googlepay=true';
                }

                var url = '/' + window.culture + '/shop/get-stripe-paymentintent?' + paymentmethod + '&ga_clientId=' + this.GAclientId();

                axios({
                    method: "get",
                    url: url,
                    data: this.OrderForm,
                }).then(function (res) {
                    if (res.data != null && res.data.success == true) {
                        that.StripeClientSecret = res.data.clientsecret;
                        if (callback) {
                            callback();
                        }
                    } else {
                        //$timeout(function () {
                        var message = res.data.exception.Message != undefined ? res.data.exception.Message : res.data.exception;
                        //    $scope.unlockCart(message);
                        this.errorPayment = message;
                        //    $scope.proceedPaymentButtonClicked = false;
                        //    $scope.completeInProgress = false;
                        //    $scope.$apply();
                        //});
                    }
                });
            },
            Pay() {
                this.errorPayment = '';
                if ((this.showTerms == false || this.checkTermsAndConditions == true) && (this.showPrivacy == false || this.checkPrivacy == true) && this.selectedPaymentoption != null) {
                    this.$emit('setLoadingFromChild', true);
                    this.proceedPaymentButtonClicked = true;
                    var that = this;
                    try {
                        window["AnalyticsBuilder"].create(window.inTestMode ? { debug: true } : {})
                            .asPaymentSelectStep({
                                step: 5,
                                checkout_step: 5,
                                checkout_option: 'Proceed payment',
                                items: that.GetGACartItems()
                            }).send();
                    } catch (e) {
                        //speciaal voor Brave browser die er uit klapt.
                    }

                    switch (this.selectedPaymentoption.code) {
                        case 'stripe2':
                            this.PayStripe();
                            break;
                        case 'klarnaPayLater':
                            this.PayKlarna('pay_later');
                            break;
                        case 'klarnaOverTime':
                            this.PayKlarna('pay_over_time');
                            break;
                        default:
                            this.CompleteOrder();
                            break;
                    }
                } else {
                    if ((this.showTerms && this.checkTermsAndConditions == false)) {
                        this.errorPayment = this.getInterfaceText('shop_please_agree_to_terms_and_conditions');
                    } else if (this.showPrivacy && this.checkPrivacy == false) {
                        this.errorPayment = this.getInterfaceText('giantid_check_privacy');
                    } else if (this.selectedPaymentoption == null) {
                        this.errorPayment = this.getInterfaceText('shop_select_payment_option');
                    }
                }
            },
            CompleteOrder() {
                var that = this;
                axios({
                    method: 'POST',
                    url: '/' + window.culture + '/shop/completeorder',
                    data: {
                        paymentoption: that.selectedPaymentoption.code,
                        //changeLocalStockToWarehouseStock: ($scope.OutOfStockValidation.OutOfStock == true && $scope.OutOfStockValidation.ContinueOrder == true),
                        ga_clientId: that.GAclientId(),
                        klarnaAuthorizationToken: this.klarnaAuthorizationToken,
                        cycleSchemeNumber: this.cyclescheme.Number,
                        cycleSchemeCode: this.cyclescheme.Code
                        //warningShown: $scope.IsWarning
                    }
                }).then(function (res) {
                    if (res.data.Result == true) {
                        if (res.data.RedirectUrl != null && res.data.RedirectUrl.length > 0) {
                            window.location = res.data.RedirectUrl;
                        }
                        //else if ($scope.paymentoption == 'affirm') {
                        //    $scope.initiateAffirm();
                        //}
                        //else if ($scope.paymentoption == 'verifone') {
                        //    $scope.initiateVerifone(res.data.Guid);
                        //}
                        //else if ($scope.paymentoption == 'paybright') {
                        //    $scope.initiatePayBright(res.data.Guid);
                        //}
                        //else if ($scope.paymentoption == 'inicis') {
                        //    $scope.initiateInicis(res.data.Guid);
                        //}
                        else {
                            //Redirect to confirmationpage
                            window.location = '/' + window.culture + '/shop/confirmation/' + res.data.Guid + '/?cartguidvalidation=' + res.data.CartGuidValidation;
                        }
                    } else {
                        that.errorPayment = res.data.ExceptionMessage;
                    }
                    that.$emit('setLoadingFromChild', false);
                    that.proceedPaymentButtonClicked = false;
                });
            },
            PayKlarna(code) {
                var that = this;
                window.Klarna.Payments.authorize({
                    payment_method_category: code
                }, function (res) {
                    if (res.approved) {
                        that.klarnaAuthorizationToken = res.authorization_token;
                        that.CompleteOrder();
                    } else {
                        that.$emit('setLoadingFromChild', false);
                        that.proceedPaymentButtonClicked = false;
                    }
                });
            },
            PayStripe() {
                var that = this;
                if (this.ShowStripeBillingAddress) {
                    axios({
                        method: 'POST',
                        url: '/' + window.culture + '/shop/setbillingaddress',
                        data: this.OrderForm,
                    }).then(function (res) {
                        if (res.data.result == true) {
                            that.CompleteStripePayment();
                        } else {
                            that.errorPayment = res.data.error;
                            this.$emit('setLoadingFromChild', false);
                            this.proceedPaymentButtonClicked = false;
                        }
                    });
                } else {
                    // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                    this.creditcardAddress.name = this.Cart.Order.Firstname + ' ' + this.Cart.Order.Lastname;
                    this.creditcardAddress.street = this.Cart.Order.Street;
                    this.creditcardAddress.zipcode = this.Cart.Order.Postalcode;
                    this.creditcardAddress.city = this.Cart.Order.City;
                    this.creditcardAddress.state = this.Cart.Order.State;
                    this.CompleteStripePayment();
                }
            },
            CompleteStripePayment() {
                var that = this;
                axios({
                    method: 'GET',
                    url: '/' + window.culture + '/shop/get-stripe-paymentintent'
                }).then(function (res) {
                    if (res.data != null && res.data.success == true) {
                        try {
                            window.stripe.handleCardPayment(
                                res.data.clientsecret, that.cardNumberElement, {
                                payment_method_data: {
                                    billing_details: {
                                        address: {
                                            city: that.creditcardAddress.city,
                                            line1: that.creditcardAddress.street,
                                            postal_code: that.creditcardAddress.zipcode,
                                            state: that.creditcardAddress.state
                                        },
                                        email: that.Cart.Order.Email,
                                        name: that.creditcardAddress.name
                                    }
                                }
                            }
                            ).then(function (result) {
                                if (result.paymentIntent != null && result.paymentIntent.status == 'succeeded') {

                                    // The payment has succeeded. Display a success message.
                                    axios({
                                        method: 'GET',
                                        url: '/' + window.culture + '/shop/stripe-statechange',
                                    }).then(function (res) {
                                        if (res.data.Success == true && res.data.RedirectUrl.length > 0) {
                                            window.location = res.data.RedirectUrl;
                                        } else {
                                            // Display error.message in your UI.
                                            that.errorPayment = 'Stripe error (unknown)';
                                        }

                                        that.$emit('setLoadingFromChild', false);
                                        this.proceedPaymentButtonClicked = false;
                                    });
                                } else {
                                    var message = 'Stripe error (unknown)';
                                    if (result.error != null) {
                                        message = 'Stripe: ' + result.error.message + ' (' + result.error.code + ')';
                                    }
                                    that.errorPayment = message;
                                    that.$emit('setLoadingFromChild', false);
                                    that.proceedPaymentButtonClicked = false;
                                }
                            });
                        } catch (error) {
                            that.errorPayment = error.message;
                            that.$emit('setLoadingFromChild', false);
                            that.proceedPaymentButtonClicked = false;
                        }
                    } else {
                        that.errorPayment = res.data;
                        that.$emit('setLoadingFromChild', false);
                        that.proceedPaymentButtonClicked = false;
                    }
                })
            },
            PaymentOptionExists(paymentoptionCode) {
                var result = false;
                if (this.Cart != null && this.Cart.PaymentOptions != null) {
                    for (var i = 0; i < this.Cart.PaymentOptions.length; i++) {
                        if (this.Cart.PaymentOptions[i].code == paymentoptionCode) {
                            result = true;
                            break;
                        }
                    }
                }
                return result;
            },
            CheckForDisableStripeAppleGooglePay() {
                var that = this;
                if (this.PaymentOptionExists('stripeApplePay') || this.PaymentOptionExists('stripeGooglePay')) {
                    this.paymentStripeRequest.canMakePayment().then(function (result) {
                        if (result && (result.applePay == true || result.googlePay == true)) {
                            //apple/google pay available
                            that.prButton.mount('#payment-request-button');
                        } else {
                            if (that.PaymentOptionExists('stripeApplePay') && (result == null || result.applePay == false)) {
                                //apple pay not available. Disable this option
                                that.Cart.PaymentOptions.filter(x => x.code == 'stripeApplePay')[0].disabled = true;
                            }
                            if (that.PaymentOptionExists('stripeGooglePay') && (result == null || result.googlePay == false)) {
                                //google pay not available. Disable this option
                                that.Cart.PaymentOptions.filter(x => x.code == 'stripeGooglePay')[0].disabled = true;
                            }
                        }
                    });
                }
            }
        },
        computed: {
            Order: {
                get() {
                    if (vueStore.state && vueStore.state.cart && vueStore.state.cart.Order) {
                        return vueStore.state.cart.Order;
                    } else {
                        return {};
                    }
                }
            },
            OrderForm: {
                get() {
                    var _order = this.Order;
                    return {
                        OrderFirstname: _order.Firstname,
                        OrderEmail: _order.Email,
                        OrderLastname: _order.Lastname,
                        OrderStreet: _order.Street,
                        OrderAddress2: _order.Address2,
                        OrderCity: _order.City,
                        OrderPostalcode: _order.Postalcode,
                        OrderState: _order.State,
                        OrderVATName: _order.VATName,
                        OrderVATNum: _order.VATNum,
                        OrderVATExtra: _order.VATExtra,
                        OrderClientType: _order.ClientType,
                        OrderLoqateKey: _order.LoqateKey,
                        OrderLatitude: _order.Latitude,
                        OrderLongitude: _order.Longitude,
                        OrderGAclientId: this.GAclientId(),
                        OrderInvoiceType: _order.InvoiceType,
                        OrderPhone: _order.Phone
                    };
                }
            },
            PayButtonLabel: {
                get() {
                    switch (this.selectedPaymentoption) {
                        case 'Alphacredit':
                            return this.getInterfaceText('shop_completewithalphacredit');
                        case 'verifone':
                            return this.getInterfaceText('shop_completewithsofinco');
                        case 'cf2':
                            return this.getInterfaceText('shop_completewithcommerzfinanz');
                        case 'affirm':
                            return this.getInterfaceText('shop_completewithaffirm');
                        default:
                            return this.getInterfaceText('shop_confirm');
                    }
                }
            },
            ShowStripeBillingAddress: {
                get() {
                    return (window.countryId == 1 || window.countryId == 10 || window.countryId == 16 || window.countryId == 43);
                }
            },
            numberOfPaymentOptions: {
                get() {
                    return this.Cart != null && this.Cart.PaymentOptions != undefined ? this.Cart.PaymentOptions.length : 0;
                }
            },
            stripeElements: {
                get() {
                    return window.stripe.elements();
                }
            },
            prButton: {
                get() {
                    var that = this;
                    return this.stripeElements.create('paymentRequestButton', { paymentRequest: that.paymentRequest });
                }
            },
            paymentStripeRequest: {
                get() {
                    return window.stripe.paymentRequest({
                        country: window.countryCode.toUpperCase(),
                        currency: window.currencyCode.toLowerCase(),
                        total: {
                            label: window.divisionFullName + ' ' + this.getInterfaceText('shop_total'),
                            amount: Math.round(this.Cart.TotalIncludingShippingCosts * 100),//calculate later
                        },
                        requestPayerName: true,
                        requestPayerEmail: true,
                    });
                }
            },
        },
        watch: {
            // whenever changes, this function will run
            selectedPaymentoption(newValue) {
                switch (newValue.code) {
                    case 'stripe2':
                        this.initiateStripe();
                        break;
                    case 'stripeApplePay':
                    case 'stripeGooglePay':
                        this.initiatestripeAppleGooglePay();
                        break;
                    case 'klarnaPayLater':
                        this.initiateKlarna('pay_later');
                        break;
                    case 'klarnaOverTime':
                        this.initiateKlarna('pay_over_time');
                        break;
                }
            },
            numberOfPaymentOptions() {
                this.CheckForDisableStripeAppleGooglePay();
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-checkout').dataset.interfacetexts);
        }
    }
</script>
